export const ClosingYearDisplayMessages = {
    lockMessage: "Closing statement for this month has been completed.",
    voidDeleteMessage: "The closing statement for this month has already been completed. Deleting and voiding are not allowed.",
} as const;